const SET_SITE_CONFIG = "@@SET_SITE_CONFIG";

const initialState = {
  siteConfig: null
};

function setSiteConfig(siteConfig) {
  return {
    type: SET_SITE_CONFIG,
    siteConfig
  };
}

function applySetSiteConfig(state, action) {
  return {
    ...state,
    siteConfig: action.siteConfig
  };
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SITE_CONFIG:
      return applySetSiteConfig(state, action);
    default:
      return state;
  }
}

const actionCreator = {
  setSiteConfig
};

export { actionCreator as configActions };
export default reducer;
